import { updatesData } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">最新动态</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">神马视频91在线视频、97视频、51视频内容更新实时追踪</p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 md:pl-10">
            <div className="absolute left-3 md:left-4 top-2 bottom-2 w-0.5 bg-background-200"></div>

            <div className="space-y-5 md:space-y-6">
              {updatesData.map((item) => {
                const tagColors: Record<string, string> = {
                  '更新': 'bg-primary-100 text-primary-700 border-primary-200',
                  '新增': 'bg-accent-100 text-accent-700 border-accent-200',
                  '优化': 'bg-secondary-100 text-secondary-700 border-secondary-200',
                  '推荐': 'bg-primary-100 text-primary-700 border-primary-200',
                  '公告': 'bg-secondary-100 text-secondary-700 border-secondary-200',
                };
                return (
                  <div key={item.id} className="relative group cursor-pointer">
                    <div className="absolute -left-[26px] md:-left-[29px] top-2 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-100 group-hover:scale-125 transition-transform"></div>
                    <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3 p-3 md:p-4 rounded-xl hover:bg-background-50 transition-colors">
                      <span className={`inline-block px-2 py-0.5 rounded text-[10px] font-medium border whitespace-nowrap w-fit ${tagColors[item.tag] || 'bg-secondary-100 text-secondary-700 border-secondary-200'}`}>
                        {item.tag}
                      </span>
                      <span className="text-sm md:text-base text-foreground-800 font-medium flex-1">{item.title}</span>
                      <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}